import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NavigationComponent } from './layout/navigation/navigation.component';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SpinnerComponent } from './spinner/spinner.component';
import { AppSpinnerDirective } from './spinner/app-spinner.directive';
export { AppSpinnerDirective };
import { ListVehiclesComponent } from './components/list-vehicles/list-vehicles.component';
import { VehicleItemComponent } from './components/vehicle-item/vehicle-item.component';
import { TimesDirective } from './directives/times.directive';
import { VehiclePlaceholderComponent } from './placeholder/vehicle-placeholder/vehicle-placeholder.component';
import { VehicleListPLaceholderComponent } from './placeholder/vehicle-list-placeholder/vehicle-list-placeholder.component';
import { ImageGalleryComponent } from './components/image-gallery/image-gallery.component';
import { ModalComponent } from './components/modal/modal.component';
import { ImageUploadComponent } from './components/image-upload/image-upload.component';
import { RequestComponent } from './components/request/request.component';
import { CustomerItemComponent } from './components/customer-item/customer-item.component';
import { SubcustomerUsersComponent } from './components/subcustomer-users/subcustomer-users.component';
import { NgbModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { ListUsersComponent } from './components/list-users/list-users.component';
import { DndDirective } from './directives/dnd.directive';
import { FilterPipe } from './pipes/filter.pipe';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { InvoicesComponent } from './components/invoices/invoices.component';
import { InvoiceItemComponent } from './components/invoice-item/invoice-item.component';
import { CreditHistoryComponent } from './components/credit-history/credit-history.component';
import { UserItemComponent } from './components/user-item/user-item.component';
import { ClientItemComponent } from './components/clients/client-item/client-item.component';
import { CustomerCardComponent } from './components/customer-card/customer-card.component';
import { FrameSetupComponent } from './components/settings-groups/frame-setup/frame-setup.component';
import { GeneralSettingsItemComponent } from './components/settings-groups/general-settings/general-settings-item/general-settings-item.component';
import { SettingsFeaturesComponent } from './components/settings-groups/general-settings/settings-features/settings-features.component';
import { GeneralSettingsSelectComponent } from './components/settings-groups/general-settings/general-settings-select/general-settings-select.component';
import { GeneralSettingsSelectImageComponent } from './components/settings-groups/general-settings/general-settings-select-image/general-settings-select-image.component';
import { GeneralSettingsCheckboxComponent } from './components/settings-groups/general-settings/general-settings-checkbox/general-settings-checkbox.component';
import { CollageSetupComponent } from './components/settings-groups/collage-setup/collage-setup.component';
import { InterfaceSetupComponent } from './components/settings-groups/interface-setup/interface-setup.component';
import { ImportersComponent } from './components/settings-groups/importers/importers.component';
import { AddUserComponent } from './components/modals/add-user/add-user.component';
import { ProfilePresetsListComponent } from './components/profile-parts/profile-presets-list/profile-presets-list.component';
import { ProfileBackgroundsListComponent } from './components/profile-parts/profile-backgrounds-list/profile-backgrounds-list.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { VehiclesSearchFieldsComponent } from './components/vehicles-search-fields/vehicles-search-fields.component';
import { ClientsSearchFieldsComponent } from './components/clients/clients-search-fields/clients-search-fields.component';
import { AddCustomerComponent } from './components/modals/add-customer/add-customer.component';
import { ThreesixtyComponent } from './components/threesixty/threesixty.component';
import { BackgroundSetupComponent } from './components/modals/background-setup/background-setup.component';
import { AllownumbersonlyDirective } from './directives/allownumbersonly.directive';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { CustomDatePipe } from './pipes/customDate.pipe';
import { ClientListComponent } from './components/clients/client-list/client-list.component';
import { ClientComponent } from './components/clients/client/client.component';
import { ClientAdminsComponent } from './components/clients/client-admins/client-admins.component';
import { FramesListComponent } from './components/frames-list/frames-list.component';
import { MarkerDirective } from './directives/marker.directive';
import { LicensePlatesListComponent } from './components/license-plates-list/license-plates-list.component';
import { LogosListComponent } from './components/logos-list/logos-list.component';
import { ClientsInvoicesComponent } from './components/modals/clients-invoices/clients-invoices.component';
import { ShowHidePasswordModule } from 'ngx-show-hide-password';
import { CarConfiguratorImportComponent } from './components/modals/car-configurator-import/car-configurator-import.component';
import { SelectWithSearchComponent } from './components/select-with-search/select-with-search.component';
import { ImportsComponent } from './components/imports/imports.component';
import { SocialConnectionsComponent } from './components/social-connections/social-connections.component';
import { InstagramAuthCallbackComponent } from './components/social-connections/instagram-auth-callback/instagram-auth-callback.component';
import { PremiumTargetsPopupComponent } from './components/modals/premium-targets-popup/premium-targets-popup.component';
@NgModule({
  declarations: [
    NavigationComponent,
    SpinnerComponent,
    AppSpinnerDirective,
    ListVehiclesComponent,
    VehicleItemComponent,
    TimesDirective,
    VehiclePlaceholderComponent,
    VehicleListPLaceholderComponent,
    ImageGalleryComponent,
    ModalComponent,
    ImageUploadComponent,
    RequestComponent,
    CustomerItemComponent,
    SubcustomerUsersComponent,
    ListUsersComponent,
    FilterPipe,
    DndDirective,
    InvoicesComponent,
    InvoiceItemComponent,
    CreditHistoryComponent,
    UserItemComponent,
    ClientItemComponent,
    CustomerCardComponent,
    FrameSetupComponent,
    GeneralSettingsItemComponent,
    SettingsFeaturesComponent,
    GeneralSettingsSelectComponent,
    GeneralSettingsSelectImageComponent,
    GeneralSettingsCheckboxComponent,
    CollageSetupComponent,
    InterfaceSetupComponent,
    ImportersComponent,
    AddUserComponent,
    ProfilePresetsListComponent,
    ProfileBackgroundsListComponent,
    VehiclesSearchFieldsComponent,
    ClientsSearchFieldsComponent,
    AddCustomerComponent,
    ThreesixtyComponent,
    BackgroundSetupComponent,
    AllownumbersonlyDirective,
    NotificationsComponent,
    CustomDatePipe,
    ClientListComponent,
    ClientComponent,
    ClientAdminsComponent,
    FramesListComponent,
    MarkerDirective,
    LicensePlatesListComponent,
    LogosListComponent,
    ClientsInvoicesComponent,
    CarConfiguratorImportComponent,
    SelectWithSearchComponent,
    ImportsComponent,
    SocialConnectionsComponent,
    InstagramAuthCallbackComponent,
    PremiumTargetsPopupComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,
    NgbPaginationModule,
    NgbModule,
    PopoverModule.forRoot(),
    NgSelectModule,
    ShowHidePasswordModule
  ],
  entryComponents: [
    SpinnerComponent
  ],
  exports: [
    NavigationComponent,
    SpinnerComponent,
    ListVehiclesComponent,
    VehicleItemComponent,
    AppSpinnerDirective,
    TranslateModule,
    VehiclePlaceholderComponent,
    VehicleListPLaceholderComponent,
    ModalComponent,
    DndDirective,
    PopoverModule,
    ImageGalleryComponent,
    UserItemComponent,
    ClientItemComponent,
    CustomerCardComponent,
    FrameSetupComponent,
    GeneralSettingsItemComponent,
    SettingsFeaturesComponent,
    GeneralSettingsSelectComponent,
    GeneralSettingsSelectImageComponent,
    GeneralSettingsCheckboxComponent,
    CollageSetupComponent,
    InterfaceSetupComponent,
    ImportersComponent,
    AddUserComponent,
    ProfilePresetsListComponent,
    ProfileBackgroundsListComponent,
    VehiclesSearchFieldsComponent,
    ClientsSearchFieldsComponent,
    AddCustomerComponent,
    BackgroundSetupComponent,
    AllownumbersonlyDirective,
    ClientComponent,
    ClientAdminsComponent,
    FramesListComponent,
    MarkerDirective,
    LicensePlatesListComponent,
    LogosListComponent,
    ClientsInvoicesComponent,
    CarConfiguratorImportComponent,
    SelectWithSearchComponent,
    ImportsComponent,
    SocialConnectionsComponent,
    InstagramAuthCallbackComponent,
    PremiumTargetsPopupComponent
  ]
})
export class SharedModule { }
